import { IProductSelosProps, cards as items } from 'utils/cards';

import CardItemMobile from './CardItemMobile';

import * as S from './styles';

interface CardsListMobileProps {
  productSelos: IProductSelosProps;
}

export default function CardsListMobile({
  productSelos,
}: CardsListMobileProps) {
  const filteredItems = items
    .filter(item => {
      // Se o item existir em productSelos e for true, mantém no array filtrado
      if (productSelos[item.id] === true) {
        return true;
      }

      // Se o item for do tipo 'importado', verifica se a string bate com o id
      if (
        item.id.startsWith('importado') &&
        item.id === productSelos.importado
      ) {
        return true;
      }

      return false;
    })
    .filter(item => item.id !== 'ultraPremio');

  return (
    <S.Container className="cards-list-mobile">
      {filteredItems.find(item => item) ? (
        filteredItems
          .map((item, index) => (
            <CardItemMobile key={index} index={index} item={item} />
          ))
          .slice(0, 4)
      ) : (
        <img
          src="/images/card-icons/desconto-progressivo-expanded-mobile.png"
          alt=""
          className="fake-image"
        />
      )}
    </S.Container>
  );
}
